import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { FormattedHTMLMessage } from 'react-intl';

class FooterLabel extends Component {
	render() {
		const { label } = this.props;
		return (
			<div className="sales-test-layout-footer-label">
				<FormattedHTMLMessage id={label} />
			</div>
		);
	}
}
FooterLabel.propTypes = {
	label: PropTypes.string.isRequired
};
export default FooterLabel;
